import { NgModule } from '@angular/core';

import { DynamicPipe } from './pipes/dynamic.pipe';
import { TableHeaderPipe } from './pipes/table-header.pipe';
import { TimeFormatPipe } from './pipes/time-format.pipe';
import { TitleCasePipe } from '@angular/common';

@NgModule({
  declarations: [DynamicPipe, TableHeaderPipe, TimeFormatPipe],
  imports: [],
  exports: [DynamicPipe, TableHeaderPipe, TimeFormatPipe],
  providers: [TitleCasePipe]
})
export class UtilsModule {}
